import React from 'react';
import styled from 'styled-components';
import styles from '@utils/styles';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import { useSportdogInternationalContext } from '@util/static-translations';

function LegalFooter() {
  const { tt } = useSportdogInternationalContext({});

  return (
    <Container>
      <span>
        ©{new Date().getFullYear()}
        <a
          href="https://www.petsafebrands.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {tt(s => s.layoutCommon.petsafeBrandsLink)}
        </a>
        <span>{tt(s => s.layoutCommon.allRightsReservedLabel)}</span>
        <LocalizedLink to="/privacy-policy" rel="nofollow">
          {tt(s => s.layoutCommon.privacyPolicyLink)}
        </LocalizedLink>
        <LocalizedLink to="/support/terms-and-conditions" rel="nofollow">
          {tt(s => s.layoutCommon.termsAndConditionsLink)}
        </LocalizedLink>
        <a
          href="https://privacyportal.onetrust.com/webform/fc0e0643-f955-43b6-a2f2-f688a8eac35c/67a2f61f-6dbe-4b5d-9800-3431b68b4024"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {tt(s => s.layoutCommon.notSellOrSharePersonalInfoLink)}
        </a>
        <button
          type="button"
          aria-label={tt(s => s.layoutCommon.cookieSettingsButtonAriaLabel)}
          onClick={() => {
            if (typeof window !== 'undefined') {
              window?.OneTrust?.ToggleInfoDisplay();
            }
          }}
        >
          {tt(s => s.layoutCommon.cookieSettingsButton)}
        </button>
      </span>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 1rem 4rem;
  text-transform: uppercase;
  color: ${styles.colors.gray[400]};
  font-size: 0.875rem;
  margin-top: 3rem;

  a,
  span,
  button {
    padding-left: 0.5rem;
  }

  a,
  button {
    color: ${styles.colors.gray[400]};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  button {
    background: transparent;
    border: none;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    text-transform: uppercase;
    cursor: pointer;
  }
`;

export default LegalFooter;
